import { LDSButton, LDSHeading } from "@resmed/lumina-design-system";

export interface NoDataViewProps {
  /** Path to the illustration image */
  image: string;
  /** Bold heading shown below the image */
  title: string;
  /** Supporting description text — lighter weight, caption colour */
  description?: string;
  /** When provided, renders a retry button */
  onRetry?: () => void;
  /** Custom label for the retry button. Defaults to "Try again" */
  retryLabel?: string;
}

/**
 * Full-panel empty/error state — mirrors the mobile NoData component.
 * Centred vertically within its container.
 */
const NoDataView = ({
  image,
  title,
  description,
  onRetry,
  retryLabel = "Try again",
}: NoDataViewProps) => (
  <div className="lds-flex lds-flex-col lds-items-center lds-justify-center lds-h-full lds-px-8 lds-py-10 lds-gap-4 lds-text-center">
    <img
      src={image}
      alt=""
      aria-hidden="true"
      className="lds-w-[55%] lds-object-contain"
    />

    <LDSHeading size="h4" className="lds-text-textcolor-default">
      {title}
    </LDSHeading>

    {description && (
      <LDSHeading
        size="h5"
        className="lds-font-normal lds-text-textcolor-caption lds-leading-[150%] lds-max-w-[280px]"
      >
        {description}
      </LDSHeading>
    )}

    {onRetry && (
      <LDSButton
        id="no-data-retry-btn"
        label={retryLabel}
        severity="default"
        size="medium"
        onClick={onRetry}
      />
    )}
  </div>
);

export default NoDataView;
